import { Dialog, DialogContent, DialogTitle, DialogActions, Button, Typography } from '@mui/material';

interface DisclaimerDialogProps {
  open: boolean;
  onAgree: () => void;
}

export default function DisclaimerDialog({ open, onAgree }: DisclaimerDialogProps) {
  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      slotProps={{ paper: { sx: { borderRadius: 2, background: 'linear-gradient(135deg, #1e293b 0%, #0f172a 100%)' } } }}
    >
      <DialogTitle sx={{ textAlign: 'center', pb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          免责声明
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ py: 4 }}>
        <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8, textAlign: 'justify' }}>
          本应用提供的题目、答案及相关内容均来源于互联网公开渠道，仅供学习交流和个人提升使用。
          本应用仅对上述内容进行收集整理，不主张、不拥有任何内容的版权。
          <br /><br />
          如您发现本应用中的内容侵犯了您的合法权益，请及时与我们联系，我们将在第一时间进行处理。
          本应用不对内容的准确性、完整性或适用性作出任何明示或默示的保证。
          <br /><br />
          您在使用本应用过程中产生的任何后果，包括但不限于因内容错误导致的学习偏差，
          均由您自行承担。本应用不对任何直接或间接损失承担责任。
          <br /><br />
          使用本应用即表示您已阅读并同意上述条款。如您不同意本声明，请立即停止使用本应用。
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 4, pb: 4, justifyContent: 'center' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={onAgree}
          sx={{
            minWidth: 200,
            height: 44,
            borderRadius: 1,
            fontWeight: 600,
            textTransform: 'none',
          }}
        >
          我已阅读并同意
        </Button>
      </DialogActions>
    </Dialog>
  );
}